export default "__VITE_ASSET__Bd8wL3oX__"